"use client"

import FieldsOfStudy from "./FieldsOfStudy"
import DashboardLayout from "@/views/dashboard/DashboardLayout"

export default function FieldsOfStudyPage() {
  return (
    <DashboardLayout>
      <FieldsOfStudy />
    </DashboardLayout>
  )
}
